import { isNonNullish } from '../../isNonNullish';

export const getHTMLAttributesList = (attributes: Record<string, string>) =>
  Object.entries(attributes)
    .filter(([_, value]) => isNonNullish(value))
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');
